'use client';

import {
  useEffect,
  useState,
} from 'react';

import { getCookieCurrentPlace } from '@/features/place/cookies/cookie-current-place';
import calculateDistance from '@/features/place/utils/calculate-distance';
import InputSlider from '@/ui/form-elements/input-range-slider/input-slider';

import styles from './listing-radius-filter.module.scss';

interface ListingRadiusFilterProps {
  setFilterLink: (link: { pathname: string; searchParams: URLSearchParams }) => void;
  filterLink: {
    pathname: string;
    searchParams: URLSearchParams;
  }
}

export default function ListingRadiusFilter(props: ListingRadiusFilterProps) {
  const {
    filterLink,
    setFilterLink,
  } = props;

  const RADIUS_MIN = 1;
  const RADIUS_MAX = 20;

  const currentDistance = Number(filterLink.searchParams.get('search_params.geo.radius_scale') ?? RADIUS_MIN);

  const [selectedScale,
    setSelectedScale] = useState<number>(currentDistance);

  const [distance,
    setDistance] = useState<string | null>(null);

  useEffect(() => {
    const currentPlace = getCookieCurrentPlace();

    const calculateFilterDistance = (scale: number) => {
      const placeDistance = currentPlace?.bbox ? calculateDistance(currentPlace.bbox) : 40;
      const kmRadius = Number(((placeDistance * Number(scale)) / 2).toFixed(1));
      const miRadius = (kmRadius * 0.621371).toFixed(1);

      return `${miRadius} mi / ${String(kmRadius)} km`;
    };

    setDistance(calculateFilterDistance(selectedScale));
  }, [selectedScale]);

  useEffect(() => {
    setSelectedScale(Number(filterLink.searchParams.get('search_params.geo.radius_scale') ?? RADIUS_MIN));
  }, [filterLink]);

  const creteNewSearchParams = (value: number) => {
    filterLink.searchParams.set('search_params.geo.radius_scale', String(value / 10));

    setSelectedScale(value / 10);
    setFilterLink({
      pathname: filterLink.pathname,
      searchParams: filterLink.searchParams,
    });
  };

  return (
    <div>
      <div className={styles.listingRadiusFilter__label}>{distance}</div>
      <InputSlider
        min={RADIUS_MIN}
        max={RADIUS_MAX}
        value={selectedScale * 10}
        onChange={creteNewSearchParams}
      />
    </div>
  );
}
